async function getOriginationFee(loanAmount, propertyCount) {
  const targetUrl = `${process.env.CMS_URL}/loans/gof`;

  const body = {
    loanAmount,
    propertyCount,
  };

  const loanQuoteResp = await fetch(targetUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    //make sure to serialize your JSON body
    body: JSON.stringify(body),
  });

  const respData = await loanQuoteResp.json();

  return respData;
}

export default getOriginationFee;
